import { useCommonData } from '../../../../common-data/useCommonData';
import { MainNavigationWrapper } from '../shared/MainNavigationWrapper';
import { Responsive } from '../../../../ui';
import { MainNavigationItems } from '../shared/MainNavigationItems';
import { SiteSectionIds } from '../../../../contentful/constants';
import MobileNavigation from '../mobile/MobileNavigation';

interface IGatewayNavigationProps {
	isSticky: boolean;
}

export default function GatewayNavigation({
	isSticky,
}: IGatewayNavigationProps) {
	const { siteSections } = useCommonData();
	const isMobile = !!Responsive.useMatchesBreakpoint('mobileXL');

	const gatewaySiteSection = siteSections.find(
		(s) => s.fields.id === SiteSectionIds.Gateway,
	);

	const gatewayMenuItems = gatewaySiteSection?.fields.menuItems;

	if (isMobile) {
		return (
			<MobileNavigation
				items={gatewayMenuItems}
				isSticky={isSticky}
				backgroundVariant="dark"
				displaySearch={false}
			/>
		);
	}

	return gatewayMenuItems ? (
		<MainNavigationWrapper
			isSticky={isSticky}
			backgroundVariant="dark"
			justifyContent="space-between"
		>
			<MainNavigationItems items={gatewayMenuItems} variant="gateway" />
		</MainNavigationWrapper>
	) : null;
}
